import React, { useState } from 'react';
import { Box, Container } from '@mui/material';
import { useOutletContext } from 'react-router-dom';
import ManageSidebar from './sidebar';
import SubscriptionsPanel from './subscriptions';
import ProfilePanel from './profile';

function ManagePage() {
    const { subscriber, onShare, onSignOut, onSync } = useOutletContext();
    const [activePanel, setActivePanel] = useState('subscriptions');

    function renderPanel() {
        if (activePanel === 'profile') {
            return <ProfilePanel subscriber={subscriber} />;
        }
        return <SubscriptionsPanel subscriber={subscriber} />;
    }

    return (
        <Container maxWidth="xl" sx={{ py: { xs: 4, md: 6 } }}>
            <Box
                sx={{
                    display: 'flex',
                    flexDirection: { xs: 'column', lg: 'row' },
                    gap: { xs: 3, lg: 5 },
                }}
            >
                <ManageSidebar
                    subscriber={subscriber}
                    activePanel={activePanel}
                    onSelect={setActivePanel}
                    onSignOut={onSignOut}
                    onShare={onShare}
                    onSync={onSync}
                />

                <Box sx={{ flex: 1, minWidth: 0 }}>
                    {renderPanel()}
                </Box>
            </Box>
        </Container>
    );
}

export default ManagePage;
